module.exports = __webpack_public_path__ + "img/appointments.552ee070.svg";